<template>
  <div
    class="third-party-root"
    :class="{ 'third-party-root--centered': isRootCentered }"
  >
    <div
      v-if="subscriptionLoading"
      v-loading="true"
      class="third-party-root__permission-loading"
      element-loading-text="加载中..."
    ></div>
    <SubscriptionNoAccessPanel
      v-else-if="!subscriptionListVisible"
      @purchase="$emit('purchase', $event)"
    />
    <template v-else>
    <div class="client-eval-notice" role="note">
      <img
        class="client-eval-notice__icon"
        src="../img/attention.png"
        alt=""
        aria-hidden="true"
      />
      <div class="client-eval-notice__content">
        <div class="client-eval-notice__title">注意事项</div>
        <p class="client-eval-notice__text">
          多账户交易期权时，请将已开通期权的账户设置为初始化账户。
        </p>
      </div>
    </div>
    <div class="search third-party-search" style="padding-top:0px;">
      <ThirdPartyAccountAdd
        ref="thirdAdd"
        :disabled="addButtonDisabled"
        @saved="loadList"
        @purchase="$emit('purchase', $event)"
      />
      <el-input
        v-model="brokerNameFilter"
        class="third-party-search__field"
        placeholder="第三方系统名称"
        clearable
        autocomplete="off"
        @keyup.enter.native="runSearch"
      />
      <el-input
        v-model="account"
        class="third-party-search__field"
        placeholder="账户"
        clearable
        autocomplete="off"
        @keyup.enter.native="runSearch"
      />
      <el-input
        v-model="name"
        class="third-party-search__field"
        placeholder="姓名"
        clearable
        autocomplete="off"
        @keyup.enter.native="runSearch"
      />
      <div>
        <input
          class="btn"
          type="button"
          style="background-color: #5b85ff; color: #fff;"
          value="搜索"
          @click="runSearch"
        />
        <input
          class="btn"
          type="reset"
          style="margin-right: 0px;"
          value="重置"
          @click.prevent="resetLocal"
        />
      </div>
    </div>
    <div class="table third-party-table">
      <el-table :data="tableData" border size="small" class="third-party-table__inner">
        <el-table-column prop="brokerName" label="第三方系统名称" min-width="265" />
        <el-table-column prop="listBrokerId" label="brokerID" min-width="100" />
        <el-table-column prop="userCode" label="登录账户" min-width="140" />
        <el-table-column prop="userName" label="登录姓名" min-width="120" />
        <!-- <el-table-column prop="userTypeName" label="账户类型" /> -->
        <el-table-column
          v-if="!hideListOperationColumns"
          label="排序"
          width="65"
        >
          <template slot-scope="scope">
            <div class="icon_sort">
              <span
                class="iconfont icon-xiangshang4"
                :style="{
                  color:
                    globalRowIndex(scope.$index) === 0
                      ? '#DCDFE6'
                      : '#5b85ff',
                  cursor:
                    globalRowIndex(scope.$index) === 0
                      ? 'default'
                      : 'pointer',
                }"
                @click="upBtn(scope.row, scope.$index)"
              ></span>
              <span
                class="iconfont icon-xiangxia4"
                :style="{
                  color:
                    globalRowIndex(scope.$index) === listTotal - 1
                      ? '#DCDFE6'
                      : '#5b85ff',
                  cursor:
                    globalRowIndex(scope.$index) === listTotal - 1
                      ? 'default'
                      : 'pointer',
                }"
                @click="downBtn(scope.row, scope.$index)"
              ></span>
            </div>
          </template>
        </el-table-column>
        <!-- 初始化账户列：暂隐藏，后续开放时恢复
        <el-table-column
          v-if="!hideListOperationColumns"
          width="110"
          align="center"
        >
          <template slot="header">
            <MarketColumnHeader />
          </template>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.market"
              disabled
              @click.native="
                market(
                  scope.row.id,
                  scope.row.userCode,
                  scope.row.market
                )
              "
            />
          </template>
        </el-table-column>
        -->
        <el-table-column
          v-if="!hideListOperationColumns"
          label="启用账户"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.visible"
              disabled
              @click.native="
                visible(
                  scope.row.id,
                  scope.row.userCode,
                  scope.row.visible
                )
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="!hideListOperationColumns"
          label="修改密码"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <i
              class="iconfont icon-xiugaimima decoration"
              :style="{
                color: '#5B85FF',
                cursor: 'pointer',
                fontSize: '18px',
              }"
              @click="openUpdatePassword(scope.row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!hideListOperationColumns"
          label="编辑"
          width="62"
          align="center"
        >
          <template slot-scope="scope">
            <i
              class="iconfont icon-bianji decoration"
              :style="{
                color: '#5B85FF',
                cursor: 'pointer',
              }"
              style="font-size: 13px"
              @click="edit_btn(scope.row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="删除" width="62" align="center">
          <template slot-scope="scope">
            <i
              class="iconfont icon-shanchu decoration"
              :style="{ color: '#5B85FF', cursor: 'pointer' }"
              @click="
                deleteItem(
                  scope.row.id,
                  scope.row.userCode
                )
              "
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_box">
      <div class="msg_count">共&nbsp;{{ listTotal }}&nbsp;条</div>
      <div class="blank"></div>
      <div class="page">
        <el-pagination
          v-if="showListPagination"
          background
          layout="prev, pager, next"
          :total="listTotal"
          :page-size="listPageSize"
          :current-page="listPageNo"
          @current-change="onListPageChange"
        />
      </div>
    </div>
    <CtpDirectUpdatePassword ref="thirdUpdatePwd" />
    </template>
  </div>
</template>

<script>
import "@/view/user/eval_jees/style.css";
import CtpDirectUpdatePassword from "../ctp_direct/CtpDirectUpdatePassword.vue";
import ThirdPartyAccountAdd from "./ThirdPartyAccountAdd.vue";
// import MarketColumnHeader from "../MarketColumnHeader.vue"; // 初始化账户列恢复时一并取消注释
import SubscriptionNoAccessPanel from "../../subscriptionService/SubscriptionNoAccessPanel.vue";
import {
  subscriptionState,
} from "../../subscriptionService/subscriptionService";
import { marketSetInitConfirmOptions } from "../marketConfirm";
import { normalizeThirdPartyListRow } from "./normalizeThirdPartyListRow";

const LIST_PAGE_SIZE = 10;

export default {
  name: "ThirdPartyAccountList",
  components: {
    ThirdPartyAccountAdd,
    CtpDirectUpdatePassword,
    // MarketColumnHeader, // 初始化账户列恢复时一并取消注释
    SubscriptionNoAccessPanel,
  },
  data() {
    return {
      tableData: [],
      brokerNameFilter: "",
      account: "",
      name: "",
      listTotal: 0,
      listPageNo: 1,
      listPageSize: LIST_PAGE_SIZE,
    };
  },
  computed: {
    showListPagination() {
      return this.listTotal >= this.listPageSize;
    },
    subscriptionLoading() {
      return subscriptionState.loading && !subscriptionState.loaded;
    },
    subscriptionListVisible() {
      return subscriptionState.view.list;
    },
    addButtonDisabled() {
      return this.subscriptionRestricted;
    },
    hideListOperationColumns() {
      return this.subscriptionRestricted;
    },
    subscriptionRestricted() {
      return subscriptionState.view.readonly;
    },
    isRootCentered() {
      return this.subscriptionLoading || !this.subscriptionListVisible;
    },
  },
  watch: {
    subscriptionListVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadList();
        }
      },
    },
  },
  methods: {
    globalRowIndex(pageRowIndex) {
      return (this.listPageNo - 1) * this.listPageSize + pageRowIndex;
    },
    buildListQueryParams() {
      const params = {
        apiToken: this.apiToken(),
        page_no: this.listPageNo,
        size: this.listPageSize,
        userType: 5,
      };
      const bname = (this.brokerNameFilter || "").trim();
      if (bname) {
        params.brokerName = bname;
      }
      const acc = (this.account || "").trim();
      if (acc) {
        params.userCode = acc;
      }
      const uname = (this.name || "").trim();
      if (uname) {
        params.userName = uname;
      }
      return params;
    },
    loadList() {
      if (!this.subscriptionListVisible) return;
      this.$axios({
        method: "post",
        url: "/cloud/eval_jees/direct_list",
        params: this.buildListQueryParams(),
      })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data && res.data.code === 200) {
            const d = res.data.data || {};
            const records = Array.isArray(d.records) ? d.records : [];
            this.listTotal = Number(d.total) || 0;
            const maxPage = Math.max(
              1,
              Math.ceil(this.listTotal / this.listPageSize) || 1
            );
            if (this.listPageNo > maxPage) {
              this.listPageNo = maxPage;
              this.loadList();
              return;
            }
            this.tableData = records.map((r) => normalizeThirdPartyListRow(r));
          } else {
            this.tableData = [];
            this.listTotal = 0;
            const msg =
              (res.data && (res.data.message || res.data.msg)) || "加载失败";
            this.$alert(msg, {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          }
        })
        .catch(() => {
          this.tableData = [];
          this.listTotal = 0;
        });
    },
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem("token") || "{}");
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    runSearch() {
      this.listPageNo = 1;
      this.loadList();
    },
    resetLocal() {
      this.brokerNameFilter = "";
      this.account = "";
      this.name = "";
      this.listPageNo = 1;
      this.loadList();
    },
    onListPageChange(page) {
      this.listPageNo = page;
      this.loadList();
    },
    upBtn(row, pageIndex) {
      const g = this.globalRowIndex(pageIndex);
      if (g <= 0) return;
      const token = this.apiToken();
      this.$axios
        .post("/cloud/eval_jees/upSort", {
          id: row.id,
          apiToken: token,
          sort: row.sort,
        })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.$message.success(
              (res.data && (res.data.message || res.data.msg)) || "排序成功"
            );
            this.loadList();
          }
        })
        .catch(() => {});
    },
    downBtn(row, pageIndex) {
      const g = this.globalRowIndex(pageIndex);
      if (g >= this.listTotal - 1) return;
      const token = this.apiToken();
      this.$axios
        .post("/cloud/eval_jees/downSort", {
          id: row.id,
          apiToken: token,
          sort: row.sort,
        })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.$message.success(
              (res.data && (res.data.message || res.data.msg)) || "排序成功"
            );
            this.loadList();
          }
        })
        .catch(() => {});
    },
    // 初始化账户列暂隐藏；恢复列时取消模板与 MarketColumnHeader 相关注释即可
    market(id, userCode, market) {
      const token = this.apiToken();
      const post = () =>
        this.$axios
          .post("/cloud/eval_jees/setMarket", { id, apiToken: token })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) this.loadList();
          })
          .catch(() => {});
      if (market) {
        this.$confirm(
          `确认不使用帐户“${userCode}”作为初始化帐户吗？`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(post)
          .catch(() => {});
      } else {
        this.$confirm(
          `确认设置帐户“${userCode}”为初始化帐户吗？<br/><span style="color:#f56c6c;">注意：杰宜斯、CTP直连账户仅可共用一个初始化账户。</span>`,
          marketSetInitConfirmOptions({
            dangerouslyUseHTMLString: true,
          })
        )
          .then(post)
          .catch(() => {});
      }
    },
    visible(id, userCode, visible) {
      const token = this.apiToken();
      const post = () =>
        this.$axios
          .post("/cloud/eval_jees/setVisible", { id, apiToken: token })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) this.loadList();
          })
          .catch(() => {});
      if (visible) {
        this.$confirm(
          `确认停用帐户“${userCode}”吗？停用会将帐户组关系解绑！停用后需重新登录多账户交易端。`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(post)
          .catch(() => {});
      } else {
        this.$confirm(
          `确认启用账户“${userCode}”吗？启用后需重新登录多账户交易端。`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(post)
          .catch(() => {});
      }
    },
    deleteItem(id, code) {
      this.$confirm(`确认删除账户“${code}”吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/cloud/eval_jees/direct_del",
            params: { id, apiToken: this.apiToken() },
          }).then((res) => {
            this.tokenInvalid(res);
            if (res.data.code === 200) {
              this.loadList();
            } else {
              this.$alert("操作失败", {
                confirmButtonText: "确定",
                type: "error",
                center: true,
              });
            }
          });
        })
        .catch(() => {});
    },
    edit_btn(row) {
      this.$nextTick(() => {
        const comp = this.$refs.thirdAdd;
        if (comp && typeof comp.openForEdit === "function") {
          comp.openForEdit(row);
        }
      });
    },
    openUpdatePassword(row) {
      this.$nextTick(() => {
        const comp = this.$refs.thirdUpdatePwd;
        if (comp && typeof comp.open === "function") {
          comp.open(row);
        }
      });
    },
  },
};
</script>

<style scoped>
.third-party-root {
  box-sizing: border-box;
  width: 100%;
}
.third-party-root > .table {
  width: 100%;
}
.third-party-root >>> .third-party-table__inner {
  width: 100% !important;
}
.third-party-root--centered {
  justify-content: center;
}
.third-party-root__permission-loading {
  min-height: 360px;
}
.third-party-root--centered .third-party-root__permission-loading {
  flex: 1;
  min-height: 0;
}
.third-party-root > .client-eval-notice {
  margin-bottom: 20px;
}
.third-party-search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}
.third-party-search >>> .third-party-search__field {
  width: 170px;
}
.third-party-search >>> .third-party-search__field .el-input__inner {
  height: 34px;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/third_party/ThirdPartyAccountList.vue